export enum CalendarMode {
  STANDARD = 0,
  ASSISTED = 1,
}

export enum DayType {
  REGULAR = 0,
  REST = 1,
  NATIONAL_HOLIDAY = 2,
  LOCAL_HOLIDAY = 3,
  COMPANY_HOLIDAY = 4,
}

export enum ActivityMode {
  WORK = "WORK",
  PERSONAL = "PERSONAL",
}

export enum TeleworkStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}
